import buildClient from '@/api/client'
import raffleQueryViewData from '@/api/raffle-query-view-data.gql'
import raffleQueryEntryAndViewDataByRaffleId from '@/api/raffle-query-entry-and-view-data-by-raffle-id.gql'
import raffleMutateEntry from '@/api/raffle-mutate-entry.gql'
import { camelizeKeys, deleteProperties } from '@/helpers/object'

const formatAddress = address => {
  const addressFormatted = camelizeKeys(address)
  deleteProperties(addressFormatted, ['countryData'])
  return addressFormatted
}

export const RAFLLE_STATES = {
  dataEntry: 'data_entry',
  entered: 'entered',
  selected: 'selected',
  rejected: 'rejected',
}

export default {
  namespaced: true,
  state: {
    id: 0,
    state: RAFLLE_STATES.data_entry,
    email: '',
    lastMakePaymentResponse: {},
    variant: {},
    shippingAddress: {},
    errors: null,
    isLoaded: false,
  },
  mutations: {
    setRaffle(state, raffle) {
      for (const key in raffle) {
        state[key] = raffle[key]
      }
    },
    setIsLoaded(state, isLoaded) {
      state.isLoaded = isLoaded
    },
    clearErrors(state) {
      state.errors = null
    },
  },
  actions: {
    async fetchRaffleEntryAndViewDataByVariantId({ dispatch }, { variantId, countryIso }) {
      await dispatch('updateRaffle', { variantId })
      const response = await buildClient().query(raffleQueryViewData)
      await dispatch('handlResponse', { ...response, countryIso })
    },

    async fetchRaffleEntryAndViewDataByRaffleId({ dispatch }, { raffleId, countryIso }) {
      const result = await buildClient().query(raffleQueryEntryAndViewDataByRaffleId, {
        raffleId,
      })
      await dispatch('handlResponse', { ...result, countryIso })
    },

    async updateRaffle(
      { dispatch, state },
      { id, variantId, email = '', shippingAddress = {}, makePaymentRequest = {} }
    ) {
      const shippingAddressFormatted = formatAddress(shippingAddress)
      const data = {
        attributes: {
          id,
          email,
          variantId,
          shippingAddress: shippingAddressFormatted,
          billingAddress: shippingAddressFormatted, // billing is same as shipping for now
          makePaymentRequest: {
            data: makePaymentRequest,
          },
        },
      }

      const response = await buildClient().query(raffleMutateEntry, data)
      await dispatch('handlResponse', response.createOrUpdateRaffleEntry)
      return state.lastMakePaymentResponse
    },

    async handlResponse(
      { commit, dispatch },
      { raffleEntry, currentOrder, territories, paths, countryIso = '' }
    ) {
      commit('setRaffle', raffleEntry)
      commit('setIsLoaded', true)
      if (currentOrder) dispatch('order/handleFetchData', { currentOrder }, { root: true })
      if (territories) dispatch('geo/handleFetchData', { territories }, { root: true })
      if (paths) dispatch('paths/handleFetchData', { paths }, { root: true })
      if (countryIso) await dispatch('geo/fetchStates', countryIso, { root: true })
    },
  },
}
